export const EN = 'en';
export const DE = 'de';
export const DEFAULT_LANGUAGE = DE;
export const LANGS = [EN, DE];
export const LOCALES = ['app'];
